<template>
  <div v-if="data.nextEvents">
    <div v-if="data.nextEvents.length > 0">
      <b-button
        v-for="(item, idx) in data.nextEvents.split(',')"
        :key="idx"
        size="sm"
        class="m-1"
        
        :variant="(item == 'Reject' || item.indexOf('<') > -1)? 'warning' :'success'"
        @click="
                submitted = true;
                callWf(
                    {event:item,

                    row:data.rowKey,
                    workflow:workflow}
                    )"
      >{{item.replace('<', '')}}</b-button>
    </div>
  </div>
  <div v-else>
    <b-button
      
      size="sm"
      class="m-1"
      variant="success"
      @click="submitted = true;
                callWf(
                  {
                  row:data.rowKey,
                  workflow:workflow
                  }

                  )"
    >{{firstStep}}</b-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import config from "@/config";
import axios from "axios";

// helpers
import eventBus from '@/helpers/event-bus'
import utils from "@/helpers/utils";

export default {
  props: ["data", "firstStep", "workflow"],
  components: {},
  data() {
    return {
      loaded: false,
      submitted: false,
      gridId:null,
    };
  },
  computed: {
    ...mapState(["currentDash"])
  },
  methods: {
    async callWf(callData) {
      callData.dashboard = this.currentDash;
      console.log('calldata',callData)

      const functionsUrl = config.midServer[process.env.APP_CONF.instance];
      const functionLink = `${functionsUrl}/callTheWf`;

      await axios
        .post(functionLink, JSON.stringify(callData))
        .then(res => {})
        .catch(err => console.log("err"));
    }
  },

  created() {
    this.submitted= false,
      console.log('button created ')

  },
  updated() {
    console.log('updated ')
    //this.submitted= false
  },
  watch: { 
      	data: function(newVal, oldVal) { // watch it
          this.submitted = false
        }
      }
};
</script>
